import {ModuleTopic, Progress} from '@cp/model';

export default function extractProgressStudyProgress(
  progress: Progress | null | undefined,
  moduleTopic: ModuleTopic,
): number {
  if (!progress) return 0;
  const studyEntry = progress.study.find((s) => s.topic === moduleTopic.topic);
  if (!studyEntry) return 0;
  if (studyEntry.done) return 100;
  // Use the progress value if available, otherwise fallback to 0
  return studyEntry.progress ? Math.round(studyEntry.progress * 100) : 0;
}
